export default __webpack_public_path__ + "static/media/muffin_logo.e0bcf3a5.svg";